import React from 'react';
import NotFoundImage from '../../assets/images/not-found.svg';
import { Button } from '@mui/material';

const FallBackError = ({ error, resetErrorBoundary }) => {
  // console.log('Error occured', {error});
  return (
    <div className="error-page">
      <img src={NotFoundImage} alt="Page not found" />
      <div className="container">
        <div className="content">
          <h1>Oops!</h1>
          <h2>Something went wrong!</h2>
          <p>
            We are really sorry but the page you requested cannot be reached from here!. But you can click the button below to go
            back to the homepage.
          </p>
          <Button autoFocus color="success" variant="contained" className="btn" onClick={resetErrorBoundary}>
            HOME
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FallBackError;
